export * from './image-watcher';
export * from './tile-watcher';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/layer/utils/index.ts